import React from 'react'
import queryString from 'query-string'

import ArrowRight from './../static/images/arrow_right_bold_stroke.svg'

class ErrorPage extends React.PureComponent {
  state = {
    gsis: false,
    tin: -1
  }

  componentWillMount = () => {
    this.props.handleError(true)

    const reversedPath = this.props.history.location.pathname
      .split('/')
      .reverse()
    const beforeEnd = reversedPath[1]
    const end = reversedPath[0]

    if ([beforeEnd, end].includes('gsis')) {
      const tin = /^[0-9]{9}$/.test(end) ? end : this.state.tin
      this.setState({ gsis: true, tin })

      let pathname = this.props.history.location.pathname
        .split('/')
        .slice(0, tin === -1 ? -1 : -2)
        .join('/')
      if (pathname[0] !== '/') {
        pathname = '/' + pathname
      }
      this.props.history.replace({ ...this.props.history.location, pathname })
    }
  }

  componentWillUnmount = () => {
    this.props.handleError(false)
  }

  render = () => (
    <div>
      {this.state.tin !== -1 && (
        <h1>
          {this.props.polyglot.t('error.existingTin', {
            tin: this.state.tin,
            contact:
              queryString.parse(this.props.history.location.search)['email'] ||
              queryString.parse(this.props.history.location.search)['phone']
          })}
        </h1>
      )}
      {this.state.tin === -1 && (
        <h1>
          {this.props.polyglot.t(
            `error.${this.state.gsis ? 'gsis' : 'generic'}`
          )}
        </h1>
      )}
      {!this.state.gsis && (
        <span>
          <p className='short_col'>{this.props.polyglot.t('error.desc')}</p>
          <p>
            {this.props.polyglot.t('errorCode')}: {this.props.error}
          </p>
        </span>
      )}
      {this.state.gsis && (
        <form action={this.props.url.gsisLogout} method='post'>
          <p className='short_col instructions'>
            {this.props.polyglot.t('gsisLogoutDesc')}
            <br />
            <br />
            <button>
              {this.props.polyglot.t('gsisLogout')} <img src={ArrowRight} />
            </button>
          </p>
        </form>
      )}
    </div>
  )
}

export default ErrorPage



// WEBPACK FOOTER //
// ./src/error-page.js